// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"731":"kubosView","939":"kubosCreate"}[chunkId] + "." + {"731":"e8bcfcb4","939":"acb24396"}[chunkId] + ".css";
};